<template>
    <q-modal v-model="show_report" :content-css="{ minWidth: '100vw', minHeight: '100vh' }" no-backdrop-dismiss no-esc-dismiss>
        <q-modal-layout>
            <q-toolbar slot="header">
                <q-btn flat round dense @click="show_report = false" icon="fas fa-times" />
                <q-toolbar-title>
                    {{ title }}
                </q-toolbar-title>
            </q-toolbar>

            <div class="layout-padding">
                <q-tabs v-model="tab" color="secondary" class="shadow-1">
                    <q-tab slot="title" name="certificates" icon="fas fa-certificate" :label="$t('certificates')" />
                    <q-tab slot="title" name="tests" icon="far fa-list-alt" :label="$t('tests')" />
                    <q-tab slot="title" name="participations" icon="fas fa-chalkboard-teacher" :label="$t('participants')" />
                    <q-tab slot="title" name="registrations" icon="far fa-check-square" :label="$t('registrations')" />
                    <q-tab slot="title" name="availables" icon="fas fa-users" :label="$t('availables')" />
                    <q-tab slot="title" name="support_material" icon="fas fa-download" :label="$t('support_material')" />
                    <q-tab slot="title" name="reaction_tests" icon="fas fa-clipboard-check" :label="$t('reaction_tests')" />
                    <q-tab slot="title" name="stars" icon="far fa-star" :label="$t('comments')" />

                    <q-tab-pane name="certificates" class="q-px-lg q-pb-xl" keep-alive>
                        <certificates :load="tab === 'certificates' && show_report_training ? true : false" :status="status" :id="id" :permissions="permissions" />
                    </q-tab-pane>

                    <q-tab-pane name="tests" class="q-px-lg q-pb-xl" keep-alive>
                        <tests :load="tab === 'tests' && show_report_training ? true : false" :id="id" :permissions="permissions" />
                    </q-tab-pane>

                    <q-tab-pane name="participations" class="q-px-lg q-pb-xl" keep-alive>
                        <participations :load="tab === 'participations' && show_report_training ? true : false" :id="id" :permissions="permissions" />
                    </q-tab-pane>

                    <q-tab-pane name="registrations" class="q-px-lg q-pb-xl" keep-alive>
                        <registrations :load="tab === 'registrations' && show_report_training ? true : false" :id="id" :permissions="permissions" />
                    </q-tab-pane>

                    <q-tab-pane name="availables" class="q-px-lg q-pb-xl" keep-alive>
                        <availables :load="tab === 'availables' && show_report_training ? true : false" :id="id" :permissions="permissions" />
                    </q-tab-pane>

                    <q-tab-pane name="support_material" class="q-px-lg q-pb-xl" keep-alive>
                        <support-material :load="tab === 'support_material' && show_report_training ? true : false" :id="id" />
                    </q-tab-pane>

                    <q-tab-pane name="reaction_tests" class="q-px-lg q-pb-xl" keep-alive>
                        <reaction-test :load="tab === 'reaction_tests' && show_report_training ? true : false" :id="id" :permissions="permissions" />
                    </q-tab-pane>

                    <q-tab-pane name="stars" class="q-px-lg q-pb-xl" keep-alive>
                        <comments :load="tab === 'stars' && show_report_training ? true : false" :id="id" :permissions="permissions" />
                    </q-tab-pane>
                </q-tabs>
            </div>
        </q-modal-layout>
    </q-modal>
</template>

<script>
import Certificates from 'components/admin/live_classes/report/Certificates'
import Tests from 'components/admin/live_classes/report/Tests'
import Participations from 'components/admin/live_classes/report/Participations'
import Registrations from 'components/admin/live_classes/report/Registrations'
import Availables from 'components/admin/live_classes/report/Availables'
import ReactionTest from 'components/admin/live_classes/report/ReactionTest'
import Comments from 'components/admin/live_classes/report/Comments'
import SupportMaterial from 'components/admin/live_classes/report/SupportMaterial'

export default {
    props: ['show_report_training', 'id', 'status', 'title', 'permissions'],

    components: {
        certificates: Certificates,
        tests: Tests,
        participations: Participations,
        registrations: Registrations,
        availables: Availables,
        'reaction-test': ReactionTest,
        comments: Comments,
        'support-material': SupportMaterial
    },

    data() {
        return {
            tab: 'certificates'
        }
    },

    computed: {
        show_report: {
            get() {
                return this.show_report_training
            },
            set() {
                this.$emit('hide_report', '')
                this.tab = 'certificates'
            }
        }
    }
}
</script>

<style></style>
